import { DataBean } from "../DataBean";

export class PayrollTypeDuplicate extends DataBean {




    public async duplicatePayrollType(idPayrollType: any, name: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.employees.PayrollType_duplicatePayrollType_Number_String", [idPayrollType, name]);
    }

}